import { combineReducers } from "redux";

// Free Version Reducers Start

import auth from "./reducers/login";
import home from "./reducers/free/homeReducer";
import dashboard from "./reducers/free/dashboardReducer";

import standardHome from "./reducers/standard/homeReducer";
import standardDashboard from "./reducers/standard/dashboardReducer";
// standard Version Reducers End

import premiumHome from "./reducers/premium/homeReducer";
import premiumDashboard from "./reducers/premium/dashboardReducer";
// premium Version Reducers End

// NRP MAIN ACTIONS START

import nrpDashboard from "./reducers/nrp/dashboardReducer";
import nrpLeaderboard from "./reducers/nrp/leaderboardReducer";
import nrpList from "./reducers/nrp/listReducer";
import nrpInvite from "./reducers/nrp/inviteReducer";

// NRP MAIN ACTIONS END
import upgrade from "./reducers/upgrade";
// upgrade redux reducer



export default combineReducers({
  auth,
  home,
  dashboard,
  standardHome,
  standardDashboard,
  premiumHome,
  premiumDashboard,
  nrpDashboard,
  nrpLeaderboard,
  nrpList,
  nrpInvite,
  upgrade,
});
